import DiscoContainerButton from "@disco-ui/button/DiscoContainerButton"
import DiscoIconButton from "@disco-ui/button/DiscoIconButton"
import DiscoIcon, { DiscoIconKinds } from "@disco-ui/icon/DiscoIcon"
import DiscoText, { DiscoTextSkeleton } from "@disco-ui/text/DiscoText"
import { Collapse } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import useFeatureFlags from "@utils/hook/useFeatureFlags"
import { TestIDProps } from "@utils/typeUtils"
import classNames from "classnames"
import { useCollapsibleSectionState } from "./CollapsibleSectionContext"
import classes from "./DiscoFormCollapsibleSection.module.css"

interface DiscoFormCollapsibleSectionProps extends TestIDProps {
  sectionId: string
  icon: DiscoIconKinds
  title: string
  description: string
  children: React.ReactNode
  openByDefault?: boolean
}

function DiscoFormCollapsibleSection({
  sectionId,
  icon,
  title,
  description,
  children,
  openByDefault = false,
}: DiscoFormCollapsibleSectionProps) {
  const { isOpen, toggleCollapsed } = useCollapsibleSectionState(sectionId, {
    openByDefault,
  })

  return (
    <div>
      <DiscoContainerButton className={classes.sectionHeader} onClick={toggleCollapsed}>
        <div className={classes.sectionIcon}>
          <DiscoIcon icon={icon} color={"var(--groovy-text-secondary)"} />
        </div>
        <div className={classes.sectionText}>
          <DiscoText variant={"body-md-600"}>{title}</DiscoText>
          <DiscoText variant={"body-sm-500"} color={"text.secondary"}>
            {description}
          </DiscoText>
        </div>
        <DiscoIconButton
          width={36}
          height={36}
          color={"var(--groovy-text-secondary)"}
          svgStyles={{ width: 20, height: 20 }}
          onClick={toggleCollapsed}
        >
          <DiscoIcon
            icon={"chevron"}
            className={classNames(classes.sectionCollapsibleIcon, {
              [classes.isCollapsed]: !isOpen,
            })}
          />
        </DiscoIconButton>
      </DiscoContainerButton>
      <Collapse in={isOpen}>
        <div className={classes.sectionContent}>{children}</div>
      </Collapse>
    </div>
  )
}

export function DiscoFormCollapsibleSectionSkeleton() {
  return (
    <div className={classes.sectionHeader}>
      <Skeleton variant={"rect"} className={classes.sectionIcon} />
      <div className={classes.sectionText}>
        <DiscoTextSkeleton variant={"body-md-600"} />
        <DiscoTextSkeleton variant={"body-sm-500"} />
      </div>
    </div>
  )
}

interface DiscoFormCollapsibleSectionGroupProps extends TestIDProps {
  children: React.ReactNode
}

function DiscoFormCollapsibleSectionGroup({
  children,
}: DiscoFormCollapsibleSectionGroupProps) {
  const { productSettingsUpdate } = useFeatureFlags()

  return (
    <div className={classNames({ [classes.sectionGroup]: productSettingsUpdate })}>
      {children}
    </div>
  )
}

DiscoFormCollapsibleSection.Group = DiscoFormCollapsibleSectionGroup

export default DiscoFormCollapsibleSection
